export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidCanvasName(name: string): boolean {
  return name.length > 0 && name.length <= 255;
}

export function isValidColorHex(color: string): boolean {
  const hexRegex = /^#(?:[0-9a-f]{3}){1,2}$/i;
  return hexRegex.test(color);
}

export function validatePoint(x: number, y: number): boolean {
  return typeof x === 'number' && typeof y === 'number' && isFinite(x) && isFinite(y);
}
